<template>
  <div class="school-body">
    <div class="container">
      <el-row type="flex" :gutter="30" class="home-top">
        <!-- 时长 -->
        <el-col :span="4">
          <div class="item-duration">
            <div class="text">
              <span>码龄</span>
              <strong>{{ loginDuration }}天</strong>
            </div>
            <img src="@/assets/image/stuUI/duration@2x.png" alt="" />
          </div>
        </el-col>
        <!-- 完成 -->
        <el-col :span="4">
          <div class="item-finish" @click="$router.push({ name: 'freeCreation' })">
            <div class="text">
              <span>自由创作</span>
              <strong>{{ workNum }}个</strong>
            </div>
            <img src="@/assets/image/stuUI/finish@2x.png" alt="" />
          </div>
        </el-col>
        <!-- 作品 -->
        <el-col :span="4">
          <div class="item-works" @click="$router.push({ name: 'classlistStuWorks' })">
            <div class="text">
              <span>课堂作品</span>
              <strong>{{ tchWorkNum }}个</strong>
            </div>
            <img src="@/assets/image/stuUI/works@2x.png" alt="" />
          </div>
        </el-col>
        <!-- 教室 -->
        <!-- <el-col :span="5">
          <div
            class="item-classroom"
            @click="
              $router.push({
                name: 'classlistIndexStu1',
              })
            "
          >
            <div class="text">
              <strong>我的教室</strong>
              <span>进入我的教室首页</span>
            </div>
            <img src="@/assets/image/stuUI/classroom@2x.png" alt="" />
          </div>
        </el-col> -->
        <!-- 星币 -->
        <el-col :span="5" v-if="$store.state.user.schoolInfo.pointAuth">
          <div class="item-starCoins" @click="$router.push({ name: 'stuStarCoinCenter' })">
            <div class="text">
              <span>我的星币</span>
              <span>
                <img src="@/assets/image/starCoin/starCoin@2x.png" alt="" />
                <strong v-if="starData">{{ starData.currentStarNum }}</strong>
              </span>
            </div>
            <img class="starCoins-img" src="@/assets/image/stuUI/starCoins@2x.png" alt="" />
          </div>
        </el-col>
        <!-- 伴学精灵 -->
        <el-col :span="7">
          <div class="virtual">
            <div class="item-image">
              <img :src="stuIndexImage" alt="" />
            </div>
            <div class="popup-box">
              <div v-html="welcomeSpeechDisplayedText"></div>
            </div>
          </div>
        </el-col>
      </el-row>
      <div class="home-create">
        <el-row :gutter="30">
          <el-col :span="6">
            <div class="item-jrcode" @click="chooseTools('jrcode')">
              <div class="text">
                <strong>Jrcode创作工坊</strong>
                <span>编程启蒙入门的首选</span>
              </div>
              <img src="@/assets/image/stuUI/jrcode@2x.png" alt="" />
            </div>
          </el-col>
          <el-col :span="6">
            <div class="item-scratch" @click="chooseTools('scratch')">
              <div class="text">
                <strong>Scratch创作工坊</strong>
                <span>最火爆的图形化语言</span>
              </div>
              <img src="@/assets/image/stuUI/scratch@2x.png" alt="" />
            </div>
          </el-col>
          <el-col :span="6">
            <div class="item-python" @click="chooseTools('python')">
              <div class="text">
                <strong>
                  Python创作工坊
                </strong>
                <span>源代码编程进阶挑战</span>
              </div>
              <img src="@/assets/image/stuUI/python@2x.png" alt="" />
            </div>
          </el-col>

          <el-col :span="6">
            <div class="item-c" @click="chooseTools('cpp')">
              <div class="text">
                <strong>C/C++创作工坊</strong>
                <span>信息学奥赛必备语言</span>
              </div>
              <img src="@/assets/image/stuUI/c++@2x.png" alt="" />
            </div>
          </el-col>
        </el-row>
      </div>
      <!-- 课堂作品 -->
      <div class="home-classroom-work" v-if="StuCourseWorks.join('') !== ''">
        <div class="title">
          <span>
            课堂作品
          </span>
          <el-link type="primary" :underline="false" @click="$router.push({ name: 'classlistStuWorks' })">
            更多<i class="el-icon-arrow-right el-icon--right"></i>
          </el-link>
        </div>
        <el-row type="flex" :gutter="30">
          <el-col :span="4" v-for="item of StuCourseWorks" :key="item.id">
            <div class="item-classroom-work" @click="LookMark(item)">
              <div class="work-tag">
                {{
                  item.work_type == "1"
                    ? "课堂"
                    : item.work_type == "2"
                    ? "作业"
                    : ""
                }}
              </div>
              <div class="img-box">
                <img :src="item.covers" alt="" />
              </div>
              <div class="work-name">
                <el-tooltip class="item" effect="dark" :content="item.title" placement="top-start">
                  <span class="work_title_span">{{
                    item.title.length > 6
                      ? item.title.slice(0, 6) + "..."
                      : item.title
                  }}</span>
                </el-tooltip>
              </div>
              <div class="stu-info">
                <img class="stu-head" :src="$store.state.user.userInfo.headimgUrl" alt="" />
                <span class="stu-name">{{
                  $store.state.user.userInfo.stuUserInfo.realName
                }}</span>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <!-- drags -->
      <!-- <div v-if="p_auth" class="home-ai" ref="refAI" :style="AIStyle" @mousedown.stop="dragStart" @touchstart.stop="dragStart" @click="ShowChatGPT">
        <img src="@/assets/image/stuUI/AI@2x.png" alt="" />
        <span>Ai助手-P仔</span>
      </div> -->
      <div :class="{'fixed-right-elem':true,'qrcode-hide':!$store.state.user.schoolInfo.wechatMiniQr && !$store.state.user.schoolInfo.wechatQr }">
        <div :class="{'home-school-communication':true,'hover-show-Qrcode':hoverShowQrcode}" @mouseenter.stop="handleHomeSchoolCommunication('hover')" @mouseleave.stop="handleMouseLeaveHomeSchoolCommunication" v-if="$store.state.user.schoolInfo.wechatMiniQr || $store.state.user.schoolInfo.wechatQr">
          <img src="@/assets/image/stuUI/homeSchoolCommunicationIcon.png" alt="" @click="handleHomeSchoolCommunication('click')" />
          <div :class="{'home-school-communication-wrapper':true, show: homeSchoolCommunicationShow}">
            <div :class="{'qrcode-tabs':true, 'only-one': !($store.state.user.schoolInfo.wechatQr && $store.state.user.schoolInfo.wechatMiniQr)}">
              <span :class="{active: QrcodeType === '公众号'}" @click="handleChangeQrcodeType('公众号')" v-if="$store.state.user.schoolInfo.wechatQr">公众号</span>
              <span :class="{active: QrcodeType === '小程序'}" @click="handleChangeQrcodeType('小程序')" v-if="$store.state.user.schoolInfo.wechatMiniQr">小程序</span>
            </div>
            <div class="qrcode-img">
              <img :src="publicAccountQrcode" alt="" v-if="QrcodeType === '公众号'">
              <img src="https://wugecdn.steam.fun/resources/static/jiaxiaotong/wechat_min_qr.jpg" alt="" v-else>
            </div>
            <img class="qrcode-right" src="@/assets/image/stuUI/homeSchoolCommunicationRight.png" alt="">
          </div>
        </div>
        <div class="home-line" v-if="$store.state.user.schoolInfo.wechatMiniQr || $store.state.user.schoolInfo.wechatQr"></div>
        <div class="home-ai" v-if="p_auth" @click="ShowChatGPT">
          <img src="@/assets/image/stuUI/homeAIIcon.png" alt="" />
        </div>
      </div>
    </div>

    <!--点评作业弹窗-->
    <el-dialog class="comment" title="课堂作品" :visible.sync="dialogFormVisible" top="5vh" width="46.5%">
      <el-row>
        <el-col :span="24">
          <div class="grid-content bg-purple">
            <el-row>
              <el-col :span="24">
                <div style="font-size: 16px; font-weight: 500" class="grid-content bg-purple-dark">
                  {{ work_title }}
                </div>
              </el-col>
            </el-row>

            <el-row style="margin-top: 10px">
              <el-col :span="9">
                <div style="line-height: 30px" class="grid-content bg-purple">
                  <span style="font-size: 12px">
                    发布于：{{ workinfo.created_time }}</span>
                </div>
              </el-col>
              <el-col :span="9">
                <div style="line-height: 30px" class="grid-content bg-purple-light">
                  <span style="font-size: 12px">
                    更新于：{{ workinfo.update_time }}</span>
                </div>
              </el-col>
            </el-row>

            <iframe style="margin-top: 10px; border: 0px" :src="
                '/scratch/player.html?work_title=' +
                  work_title +
                  '&work_url=' +
                  work_url +
                  '&scale=' +
                  scale
              " :width="frameWidth" :height="frameHeight"></iframe>

            <el-row>
              <el-col :span="24">
                <div style="font-size: 14px; margin-top: 10px" class="grid-content bg-purple-dark">
                  <ul>
                    <el-button type="text" style="margin-right: 20px; cursor: pointer" class="el-icon-view" @click="LookCode">查看源码</el-button>
                    <el-popover placement="top-start" title="手机分享" width="150" trigger="click" content="手机分享作品，赶快体验吧!">
                      <div id="qrcodeImg"></div>
                      <i @click="qrcode" slot="reference" style="margin-right: 20px; cursor: pointer" class="el-icon-share">分享</i>
                    </el-popover>
                  </ul>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
    </el-dialog>

    <!--点评作业弹窗-->
    <el-dialog class="comment" title="课堂作品" :visible.sync="dialogFormVisible1" top="5vh" width="80%">
      <el-row>
        <el-col :span="24">
          <div class="grid-content bg-purple">
            <el-row>
              <el-col :span="24">
                <div style="font-size: 16px; font-weight: 500" class="grid-content bg-purple-dark">
                  {{ work_title }}
                </div>
              </el-col>
            </el-row>

            <el-row style="margin-top: 10px">
              <el-col :span="9">
                <div style="line-height: 30px" class="grid-content bg-purple">
                  <span style="font-size: 12px">
                    发布于：{{ workinfo.created_time }}</span>
                </div>
              </el-col>
              <el-col :span="9">
                <div style="line-height: 30px" class="grid-content bg-purple-light">
                  <span style="font-size: 12px">
                    更新于：{{ workinfo.update_time }}</span>
                </div>
              </el-col>
            </el-row>
            <iframe style="margin-top: 10px; border: 0px" :src="'/jrcode/teashow.html?mode=look&filepath=' + work_url" :width="frameWidth1" :height="frameHeight1"></iframe>
          </div>
        </el-col>
      </el-row>
    </el-dialog>

    <el-dialog title="编程工具" :visible.sync="dialogVisible" width="65%" append-to-body>
      <el-row style="text-align: center">
        <el-col :span="6">
          <div class="tools">
            <div>
              <el-image style="width: 150px; height: 150px; border-radius: 5px" src="https://scratchshop.oss-cn-shanghai.aliyuncs.com/courses/%E5%88%9B%E4%BD%9C%E9%80%89%E6%8B%A9-01.png" fit="fill"></el-image>
            </div>
            <div style="margin-top: -20px; font-size: 16px; font-weight: bold">
              <svg style="position: relative; top: 4px" v-if="!jr_show" t="1666275059447" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2880" width="18" height="18">
                <path d="M752 419.2h-64V304.1C688 207 609 128 512 128s-176 79-176 176.1v115.1h-64V304.1c0-64.1 25-124.4 70.3-169.8C387.6 89 447.9 64 512 64s124.4 25 169.7 70.3C727 179.7 752 240 752 304.1v115.1z" fill="#727272" p-id="2881"></path>
                <path d="M864 507.7v360.2c0 50.8-40.5 92.1-90.2 92.1H250.2c-49.7 0-90.2-41.3-90.2-92.1V507.7c0-50.8 40.5-92.1 90.2-92.1h523.6c49.7 0.1 90.2 41.4 90.2 92.1z" fill="#E6C27C" p-id="2882"></path>
              </svg>
              Jrcode
            </div>
            <div style="margin-top: 0px; color: #909399">
              编程启蒙<span style="cursor: pointer" @click="ClearChrome">入门</span>的首选
            </div>
            <div>
              <el-button :disabled="!jr_show" @click="chooseTools('jrcode')" style="margin-top: 21px" type="success" size="small">Let's code</el-button>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="tools">
            <div>
              <el-image style="width: 150px; height: 150px; border-radius: 5px" src="https://scratchshop.oss-cn-shanghai.aliyuncs.com/courses/%E5%88%9B%E4%BD%9C%E9%80%89%E6%8B%A9-02.png" fit="fill"></el-image>
            </div>
            <div style="margin-top: -20px; font-size: 16px; font-weight: bold">
              <svg style="position: relative; top: 4px" v-if="!sc_show" t="1666275059447" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2880" width="18" height="18">
                <path d="M752 419.2h-64V304.1C688 207 609 128 512 128s-176 79-176 176.1v115.1h-64V304.1c0-64.1 25-124.4 70.3-169.8C387.6 89 447.9 64 512 64s124.4 25 169.7 70.3C727 179.7 752 240 752 304.1v115.1z" fill="#727272" p-id="2881"></path>
                <path d="M864 507.7v360.2c0 50.8-40.5 92.1-90.2 92.1H250.2c-49.7 0-90.2-41.3-90.2-92.1V507.7c0-50.8 40.5-92.1 90.2-92.1h523.6c49.7 0.1 90.2 41.4 90.2 92.1z" fill="#E6C27C" p-id="2882"></path>
              </svg>
              Scratch
            </div>
            <div style="margin-top: 0px; color: #909399">
              最火爆的图形化语言
            </div>
            <div>
              <el-button :disabled="!sc_show" @click="chooseTools('scratch')" style="margin-top: 21px" type="warning" size="small">Let's code</el-button>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="tools">
            <div>
              <el-image style="width: 150px; height: 150px; border-radius: 5px" src="https://scratchshop.oss-cn-shanghai.aliyuncs.com/courses/%E5%88%9B%E4%BD%9C%E9%80%89%E6%8B%A9-12.png" fit="fill"></el-image>
            </div>
            <div style="margin-top: -20px; font-size: 16px; font-weight: bold">
              <svg style="position: relative; top: 4px" v-if="!python_show" t="1666275059447" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2880" width="18" height="18">
                <path d="M752 419.2h-64V304.1C688 207 609 128 512 128s-176 79-176 176.1v115.1h-64V304.1c0-64.1 25-124.4 70.3-169.8C387.6 89 447.9 64 512 64s124.4 25 169.7 70.3C727 179.7 752 240 752 304.1v115.1z" fill="#727272" p-id="2881"></path>
                <path d="M864 507.7v360.2c0 50.8-40.5 92.1-90.2 92.1H250.2c-49.7 0-90.2-41.3-90.2-92.1V507.7c0-50.8 40.5-92.1 90.2-92.1h523.6c49.7 0.1 90.2 41.4 90.2 92.1z" fill="#E6C27C" p-id="2882"></path>
              </svg>
              Python
            </div>
            <div style="margin-top: 0px; color: #909399">
              源代码编程进阶挑战
              <span style="cursor: pointer" @click="Update">
                <svg t="1658209599264" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8284" width="20" height="20">
                  <path d="M512 56.888889a455.111111 455.111111 0 1 1 0 910.222222A455.111111 455.111111 0 0 1 512 56.888889zM417.507556 332.344889H285.809778L439.751111 739.555556h136.419556l151.096889-407.210667h-127.772445L509.155556 625.379556 417.564444 332.344889z" p-id="8285" fill="#1296db"></path>
                </svg>
              </span>
            </div>
            <div>
              <el-button :disabled="!python_show" @click="chooseTools('python')" style="margin-top: 18px; background: #807be0; color: white" size="small">Let's code</el-button>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="tools">
            <div>
              <el-image style="width: 150px; height: 150px; border-radius: 5px" src="https://wugecdn.steam.fun/resources/static/images/C_logo.png" fit="fill"></el-image>
            </div>
            <div style="margin-top: -20px; font-size: 16px; font-weight: bold">
              <svg style="position: relative; top: 4px" v-if="!cplus_show" t="1666275059447" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2880" width="18" height="18">
                <path d="M752 419.2h-64V304.1C688 207 609 128 512 128s-176 79-176 176.1v115.1h-64V304.1c0-64.1 25-124.4 70.3-169.8C387.6 89 447.9 64 512 64s124.4 25 169.7 70.3C727 179.7 752 240 752 304.1v115.1z" fill="#727272" p-id="2881"></path>
                <path d="M864 507.7v360.2c0 50.8-40.5 92.1-90.2 92.1H250.2c-49.7 0-90.2-41.3-90.2-92.1V507.7c0-50.8 40.5-92.1 90.2-92.1h523.6c49.7 0.1 90.2 41.4 90.2 92.1z" fill="#E6C27C" p-id="2882"></path>
              </svg>
              C/C++
            </div>
            <div style="margin-top: 0px; color: #909399">
              信息学奥赛必备语言
            </div>
            <div>
              <el-button :disabled="!cplus_show" @click="chooseTools('cpp')" style="margin-top: 22px; background: #0280ce; color: white" size="small">Let's code</el-button>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-dialog>

    <!--PYTHON点评作业弹窗-->
    <el-dialog class="comment" title="课堂作品" :visible.sync="dialogFormVisible2" top="5vh" width="80%">
      <el-row>
        <el-col :span="24">
          <div class="grid-content bg-purple">
            <el-row>
              <el-col :span="24">
                <div style="font-size: 16px; font-weight: 500" class="grid-content bg-purple-dark">
                  {{ work_title }}
                </div>
              </el-col>
            </el-row>

            <el-row style="margin-top: 10px">
              <el-col :span="9">
                <div style="line-height: 30px" class="grid-content bg-purple">
                  <span style="font-size: 12px">
                    发布于：{{ workinfo.created_time }}</span>
                </div>
              </el-col>
              <el-col :span="9">
                <div style="line-height: 30px" class="grid-content bg-purple-light">
                  <span style="font-size: 12px">
                    更新于：{{ workinfo.update_time }}</span>
                </div>
              </el-col>
            </el-row>
            <iframe style="margin-top: 10px; border: 0px" :src="python_work_url" :width="frameWidth2" :height="frameHeight2"></iframe>
          </div>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <div class="grid-content bg-purple-light">
            <el-row>
              <el-col :span="24">
                <div style="font-size: 16px; font-weight: 500" class="grid-content bg-purple-dark">
                  老师点评
                </div>
              </el-col>
            </el-row>

            <el-form :model="markform" ref="ruleForm" label-width="100px" :inline="true" size="mini" style="margin-top: 10px" class="demo-ruleForm">
              <el-form-item label="作品等级" prop="markpoint">
                <el-rate disabled v-model="markform.markpoint"> </el-rate>
              </el-form-item>
              <el-form-item label="作品推优" prop="is_good">
                <el-switch disabled v-model="markform.is_good"></el-switch>
              </el-form-item>
              <el-form-item label="作品评语" prop="remark">
                <span style="margin-top: 10px"> {{ markform.remark }}</span>
              </el-form-item>
            </el-form>
          </div>
        </el-col>
      </el-row>
    </el-dialog>

    <!--ChatGPT-->
    <el-drawer title="Ai助手-P仔" :visible.sync="drawerAI" :with-header="false" size="50%">
      <!--
      <iframe style="width: 100%; height: 100vh;overflow:hidden;" src="https://ai.wugedianxia.cn"></iframe>
     -->
      <div style="overflow-y: scroll;">
        <div style="text-align: center;margin-top:20px;color:#5e8ff8;font-size: 24px;font-weight: bold;">
          与Ai对话
        </div>
        <div style="text-align: center;margin-top:0px;color:#c7c8ca;font-size: 14px;font-weight: bold;">
          输入你想问的问题
        </div>

        <div style="padding:20px;">
          <el-input type="textarea" :rows="8" maxlength="5000" show-word-limit placeholder="你好编程少年，你有什么问题，我都可以回答你哦！" v-model="request_info">
          </el-input>
        </div>

        <div style="text-align:center;">
          <el-button size="small" type="primary" @click="generate_ai()" :loading="loading">立即提问</el-button>

          <el-button size="small" @click="ResetAi">重置<i class="el-icon-delete el-icon--right"></i></el-button>
        </div>

        <div style="text-align: center;margin-top: 20px;border:1px solid #d9dde5;margin: 20px;border-radius: 10px;padding:20px;">
          <div v-if="!streamCache">
            <el-image style="width:20%;" class="contant_img_2" src="https://wugecdn.steam.fun/resources/static/AI_A.png" fit="fill"></el-image>
          </div>

          <div v-if="!streamCache" style="font-size: 18px;font-weight: bold;">
            等待您的输入
          </div>
          <div v-if="!streamCache">点击提问按钮开始吧</div>

          <mavon-editor v-if="streamCache" :style="{ 'min-height': '0px', 'margin-top': '20px' }" preview-background="#fff" v-model="ai_text" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
        </div>
      </div>
    </el-drawer>

  </div>
</template>

<script>
// api
import {
  stuGetStuTodayCourse,
  stuGetIndexTchWorkList,
  stuGetStuSubjectAuth,
  getStuIndexNumInfoForNew,
} from "@/api/classroom/student_api";
import { getGhatGptToken, getQrCodeForStu } from "@/api/educational.js";
import { getZoneSchoolSubjectList } from "@/api/community";
import { api_stuStuStarPersonalSoa } from "@/api/javaApi";
// plugin
import QRCode from "qrcodejs2"; // 引入qrcode

// 在Vue组件中引入markdown-it
import MarkdownIt from "markdown-it";
import hljs from "highlight.js";
import "highlight.js/styles/base16/monokai.css";
import cpp from "highlight.js/lib/languages/cpp";
hljs.registerLanguage("cpp", cpp);

// 使用markdown-it
let md = new MarkdownIt({
  highlight: function (str, lang) {
    if (lang && hljs.getLanguage(lang)) {
      try {
        return (
          '<pre class="hljs"><code>' +
          hljs.highlight(lang, str, true).value +
          "</code></pre>"
        );
      } catch (error) {
        console.log(error);
      }
    }
    return (
      '<pre class="hljs"><code>' + md.utils.escapeHtml(str) + "</code></pre>"
    );
  },
});

export default {
  name: "classroomIndexStu",
  data() {
    return {
      p_auth: true,
      homeSchoolCommunicationShow: false,
      hoverShowQrcode: false,
      QrcodeType: '公众号', // 公众号 / 小程序
      publicAccountQrcode: '', // 公众号二维码

      todayCourse: [],
      todayTchPlanList: [], //学生今日课程
      StuCourseWorks: [], //前4个课堂作品

      markform: {},
      work_title: "",
      work_url: "",
      workinfo: {},
      dialogFormVisible: false,
      dialogFormVisible1: false,
      dialogFormVisible2: false,

      //作品尺寸适配
      frameWidth: 0, // 屏幕宽
      frameHeight: 0, // 屏幕高
      scale: 0,
      //JRCODE作品点评
      frameWidth1: 0, // 屏幕宽
      frameHeight1: 0, // 屏幕高

      //PY课程作品
      frameWidth2: 0, // 屏幕宽
      frameHeight2: 0, // 屏幕高

      python_work_url: "",

      dialogVisible: false, //编程工具
      subjectList: [], //学生的科目权限
      jr_show: false,
      sc_show: false,
      python_show: false,
      cplus_show: false,

      //P仔
      api_key: "",
      drawerAI: false,
      textarea: "",

      //Ai服务器
      streamCache: "",
      loading: false,
      request_info: "",
      ai_text: "",

      // 统计信息
      workNum: null, //自由作品数
      tchWorkNum: null, //课堂作品数
      loginDuration: 0, // 登录时长
      starData: null, // 星币信息
      drags: {
        elem: null,
        dragging: false,
        offsetTop: 0,
        offsetLeft: 0,
        offsetX: 0,
        offsetY: 0,
        windowDiffWidth: 0,
        windowDiffHeight: 0,
        initPosition: "0-0",
      },
      welcomeSpeechFullText:
        "嗨小朋友们！我是你们的好朋友博克斯！快快来星币中心兑换你们喜欢的伴学精灵吧！它们会帮你们变得更聪明、更好玩，一起探索学习的乐趣吧！小伙伴们，赶紧行动起来吧！",
      welcomeSpeechDisplayedText: "",
      typewriterInterval: null,
      schoolIdTest: '',
      stuTchPlanIdTest: ''
    };
  },
  computed: {
    AIStyle() {
      return {
        position: "fixed",
        top: `${this.drags.offsetTop}px`,
        left: `${this.drags.offsetLeft}px`,
      };
    },
    stuIndexImage() {
      return (
        this.$store.state.resource.spriteUrl ||
        "https://wugecdn.steam.fun/resources/static/student/box.png"
      );
    },
  },
  mounted() {
    this.drags.elem = this.$refs.refAI;
    if (this.drags.elem) {
      this.drags.offsetLeft = window.innerWidth - 110;
      this.drags.offsetTop = window.innerHeight / 1.5;
      this.drags.windowDiffWidth = window.innerWidth - this.drags.offsetLeft;
      this.drags.windowDiffHeight = window.innerHeight - this.drags.offsetTop;
    }
    this.frameWidth = document.documentElement.clientWidth * 0.8 * 0.583 - 50;
    this.frameHeight = this.frameWidth * 0.75 + 55;

    this.frameWidth1 = document.documentElement.clientWidth * 0.8 - 50;
    this.frameHeight1 = this.frameWidth1 * 0.5 + 55;

    this.frameWidth2 = document.documentElement.clientWidth * 0.8 - 50;
    this.frameHeight2 = this.frameWidth1 * 0.5 + 55;

    this.scale = this.frameWidth / 480;

    if (this.$store.state.user.token) {
      this.freshData();
    }

    this.stuGetStuTodayCourse();
    this.stuGetIndexTchWorkList(); //学生SC科目的课堂作品前4个
    //this.stuGetStuSubjectAuth();
    this.getZoneSchoolSubjectList();
    this.getStuIndexNumInfoForNew();
    this.stuStuStarPersonalSoa();
    window.addEventListener("resize", this.methodMoveAI);
    if (this.$store.state.user.schoolInfo.wechatQr) {
      this.QrcodeType = '公众号'
    } else {
      this.QrcodeType = '小程序'
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.methodMoveAI);
  },
  methods: {
    methodMoveAI() {
      this.drags.offsetLeft = window.innerWidth - this.drags.windowDiffWidth;
      // 高不变
      // this.drags.offsetTop = window.innerHeight - this.drags.windowDiffHeight
    },
    ResetAi() {
      this.request_info = "";
      this.streamCache = "";
    },
    dragStart(e) {
      // console.log("触发了dragStart");
      e.preventDefault();
      this.drags.dragging = true;
      this.drags.offsetX = e.clientX - this.drags.offsetLeft;
      this.drags.offsetY = e.clientY - this.drags.offsetTop;
      this.drags.initPosition = `${this.drags.offsetLeft}-${this.drags.offsetTop}`;
      document.addEventListener("mousemove", this.dragMove);
      document.addEventListener("touchmove", this.dragMove);
      document.addEventListener("mouseup", this.dragEnd);
      document.addEventListener("touchend", this.dragEnd);
    },
    dragMove(e) {
      // console.log("触发了dragMove");
      if (this.drags.dragging) {
        this.drags.offsetLeft = e.clientX - this.drags.offsetX;
        this.drags.offsetTop = e.clientY - this.drags.offsetY;
      }
    },
    dragEnd() {
      // console.log("触发了dragEnd");
      // 使用setTimeout避免快速点击
      this.drags.dragging = false;
      this.drags.windowDiffWidth = window.innerWidth - this.drags.offsetLeft;
      this.drags.windowDiffHeight = window.innerHeight - this.drags.offsetTop;
      document.removeEventListener("mousemove", this.dragMove);
      document.removeEventListener("touchmove", this.dragMove);
      document.removeEventListener("mouseup", this.dragEnd);
      document.removeEventListener("touchend", this.dragEnd);
    },
    methodStartTypewriter() {
      this.welcomeSpeechDisplayedText = "";
      clearInterval(this.typewriterInterval);
      this.typewriterInterval = setInterval(() => {
        if (
          this.welcomeSpeechDisplayedText.length ===
          this.welcomeSpeechFullText.length + 1
        ) {
          clearInterval(this.typewriterInterval);
        } else {
          this.welcomeSpeechDisplayedText = this.welcomeSpeechFullText.substring(
            0,
            this.welcomeSpeechDisplayedText.length + 1
          );
        }
      }, 100); // 每100毫秒添加一个字符
    },
    //动态获得GPT-TOKEN
    async getGhatGptToken() {
      return getGhatGptToken().then((res) => {
        console.log("动态获取GPT");
        console.log(res.chatGptKeyList);
        localStorage.setItem("gpt_token", res.chatGptKeyList[0].key);
        return true;
      });
    },

    //Ai调用函数
    async generate_ai(textParams = "") {
      const getAITokenRs = await this.getGhatGptToken();
      console.log("chatgpt 聊天", getAITokenRs);
      if (!textParams && !this.request_info)
        return this.$message.error("请输入聊天内容");
      if (!getAITokenRs) return this.$message.error("AI Token失效");
      console.log("新的Ai服务器");

      this.streamCache = "";
      this.loading = true;

      fetch("https://ai.wugedianxia.cn/api/chat/completions", {
        method: "POST",
        body: JSON.stringify({
          text: textParams || this.request_info,
          //sessionId: 894,
          appId: this.drawerAI ? 60 : 62,
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("gpt_token"),
        },
      }).then((res) => {
        console.log("新人工智能服务器返回");
        // console.log(res)

        const reader = res.body.getReader();
        const decoder = new TextDecoder("utf-8");
        // console.log('reader:', reader)
        // console.log('decoder:', decoder)
        let that = this;
        reader.read().then(async function processText(res) {
          // console.log('循环读取信息')
          // console.log(res)

          if (res.done || !that.loading) {
            return;
          }

          const decodeContent = decoder.decode(res.value);

          // console.log('decodeContent')
          // console.log(decodeContent)

          // error
          if (decodeContent.includes(`"error": {\n`)) {
            console.log("账户错误");
            console.log(decodeContent);
            that.loading = false;
            return;
          }

          // done
          if (decodeContent.includes("data: [DONE]")) {
            that.loading = false;
            console.log("回答完成");
            return;
          }

          decodeContent
            .replaceAll("data: ", "")
            .split("\n")
            .filter(Boolean)
            .forEach(async (item) => {
              // console.log(item)
              const itemObj = JSON.parse(item);

              // console.log('新服务器回答')
              // console.log(itemObj)

              if (
                !itemObj.data ||
                Object.prototype.toString.call(itemObj.data) ===
                "[object Object]"
              ) {
                return;
              }
              const str = itemObj.data;

              that.streamCache += str;
              if (that.request_info) {
                that.ai_text = md.render(that.streamCache);
              } else if (textParams) {
                that.welcomeSpeechDisplayedText = md.render(that.streamCache);
                sessionStorage.setItem('welcomeSpeechDisplayedText', that.welcomeSpeechDisplayedText);
              }
            });

          return reader.read().then(processText);
        });
      });
    },

    goZome() {
      this.$store.dispatch("freshUserData").then((res) => {
        console.log(res, 145412);
        if (res.identity === 2) {
          if (res.userInfo.zoneAuth === false) {
            this.$message.warning("暂无权限");
          } else {
            this.$router.push({ name: "community-explore" });
          }
        }
        if (res.identity === 1) {
          this.$router.push({ name: "community-explore" });
        }
      });
    },
    Update() {
      console.log("检测python当前版本");

      if (localStorage.getItem("current_py_version") == "v2") {
        this.$confirm(
          "是否切换至v1版本编辑器,配合老版本客户端或者网页小助手使用！",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        ).then(() => {
          this.$message.success("已切换至v1版本编辑器！");
          localStorage.setItem("current_py_version", "v1");
        });
      } else if (localStorage.getItem("current_py_version") == "v1") {
        this.$confirm(
          "是否切换至v2版本编辑器,配合新版本客户端或者网页小助手使用！",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        ).then(() => {
          this.$message.success("已切换至v2版本编辑器！");
          localStorage.setItem("current_py_version", "v2");
        });
      } else {
        this.$confirm(
          "是否切换至v1版本编辑器,配合新版本客户端或者网页小助手使用！",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        ).then(() => {
          this.$message.success("已切换至v1版本编辑器！");
          localStorage.setItem("current_py_version", "v1");
        });
      }
    },
    //刷新账号信息
    freshData() {
      this.$store.dispatch("freshUserData").then((res) => {
        console.log("刷新用户信息");
        // this.$store.dispatch('getStuTitleUrl')
        console.log(res);
        this.p_auth = res.userInfo.pauth;
        if (this.$store.state.resource.cueWord) {
          const { realName } = this.$store.state.user.userInfo.stuUserInfo;
          const stuText = `。我是${realName}`;
          const welcomeSpeechDisplayedText = sessionStorage.getItem('welcomeSpeechDisplayedText');
          if (welcomeSpeechDisplayedText) {
            this.welcomeSpeechFullText = welcomeSpeechDisplayedText
            this.methodStartTypewriter();
          } else {
            this.generate_ai(this.$store.state.resource.cueWord + stuText);
          }
        } else {
          this.methodStartTypewriter();
        }
      });
    },

    ClearChrome() {
      window.open("/jrcode/home.html", "_bank");
    },

    //获取学校科目权限列表
    stuGetStuSubjectAuth() {
      console.log("查询学生科目权限");
      stuGetStuSubjectAuth().then((res) => {
        this.subjectList = res.subjectList;
        console.log("获取科目权限权限列表");
        console.log(res);

        if (res.subjectList.length == 0) {
          this.jr_show = false;
          this.sc_show = false;
          this.python_show = false;
          this.cplus_show = false;
          return;
        }

        for (let k = 0; k < res.subjectList.length; k++) {
          if (res.subjectList[k].code == "1") {
            this.jr_show = true;
          } else if (res.subjectList[k].code == "2") {
            this.sc_show = true;
          } else if (res.subjectList[k].code == "3") {
            this.python_show = true;
          } else if (res.subjectList[k].code == "4") {
            this.cplus_show = true;
          }
        }
      });
    },

    //查询校区科目权限
    getZoneSchoolSubjectList() {
      getZoneSchoolSubjectList().then((res) => {
        console.log("获得校区科目列表");
        console.log(res);
        this.subjectList = res.subjectList;
        if (res.subjectList.length == 0) {
          this.jr_show = false;
          this.sc_show = false;
          this.python_show = false;
          this.cplus_show = false;
          return;
        }

        for (let k = 0; k < res.subjectList.length; k++) {
          if (res.subjectList[k].code == "1") {
            this.jr_show = true;
          } else if (res.subjectList[k].code == "2") {
            this.sc_show = true;
          } else if (res.subjectList[k].code == "3") {
            this.python_show = true;
          } else if (res.subjectList[k].code == "4") {
            this.cplus_show = true;
          }
        }
      });
    },

    //获得学生今日课程
    stuGetStuTodayCourse() {
      stuGetStuTodayCourse().then((res) => {
        console.log("获得学生今日课程");
        console.log(res);
        this.todayTchPlanList = res.todayTchPlanList;
      });
    },

    //学生的最新课堂作品
    stuGetIndexTchWorkList() {
      stuGetIndexTchWorkList({}).then((res) => {
        console.log("查询学生前4个课堂作品及作业");
        console.log(res);
        this.StuCourseWorks = res.workList;
      });
    },

    LookMark(item) {
      console.log("item111");
      console.log(item);
      console.log(item.subject_code);
      this.workinfo = item;
      this.markform.is_good = item.is_good;
      this.markform.markpoint = item.markpoint;
      this.markform.remark = item.remark;
      this.work_title = item.title;
      this.work_url = item.work_url;
      this.stuTchPlanIdTest = item.stu_tch_plan_id
      this.schoolIdTest = item.educational_institution_id

      if (item.subject_code == "1") {
        this.dialogFormVisible1 = true;
      } else if (item.subject_code == "2") {
        this.dialogFormVisible = true;
      } else if (item.subject_code == "3") {
        if (localStorage.getItem("current_py_version") == "v2") {
          this.$router.push({
            name: "python_course_v2",
            query: {
              type: "3",
              title: item.title,
              plan_id: item.stu_tch_plan_id,
              operate: item.work_type == 2 ? "4" : "2",
            },
            params: {
              work_url: item.work_url,
            },
          });
        } else if (localStorage.getItem("current_py_version") == "v1") {
          this.$router.push({
            name: "python_course",
            query: {
              type: "3",
              title: item.title,
              plan_id: item.stu_tch_plan_id,
              operate: item.work_type == 2 ? "4" : "2",
            },
            params: {
              work_url: item.work_url,
            },
          });
        } else {
          this.$router.push({
            name: "python_course_v2",
            query: {
              type: "3",
              title: item.title,
              plan_id: item.stu_tch_plan_id,
              operate: item.work_type == 2 ? "4" : "2",
            },
            params: {
              work_url: item.work_url,
            },
          });
        }
      } else if (item.subject_code == '4') {
        const cpp_url =
          '/cpp?' +
          '&lesson_id=' +
          item.lessionId +
          '&stu_id=' +
          item.stu_user_id +
          '&type=' +
          item.work_type +
          '&userType=' +
          'stu'
        sessionStorage.setItem('lecturesTitle', item.title)
        sessionStorage.setItem('sbj', '4')

        // window.open(cpp_url, '_blank')
        location.href = cpp_url;
      }
    },

    chooseTools(cmd) {
      console.log(cmd);
      const warningTip = "暂未开通本课程，无法开始创作";
      if (cmd == "jrcode") {
        if (!this.jr_show) return this.$message.warning(warningTip);
        window.location.href =
          "/jrcode/create.html?mode=edit&filepath=https://steamfun-cdn.oss-cn-zhangjiakou.aliyuncs.com/resources/jrcode/project.sjr";
      } else if (cmd == "scratch") {
        if (!this.sc_show) return this.$message.warning(warningTip);
        window.location.href = "/scratch/index.html";
      } else if (cmd == "python") {
        if (!this.python_show) return this.$message.warning(warningTip);
        if (localStorage.getItem("current_py_version")) {
          if (localStorage.getItem("current_py_version") == "v2") {
            this.$router.push({
              name: "python_editor_v2",
            });
          } else if (localStorage.getItem("current_py_version") == "v1") {
            this.$router.push({
              name: "python_editor",
            });
          }
        } else {
          this.$router.push({
            name: "python_editor_v2",
          });

          localStorage.setItem("current_py_version", "v2");
        }
      } else if (cmd === "cpp") {
        if (!this.cplus_show) return this.$message.warning(warningTip);
        window.location.href = "/cpp/editor";
      }
    },

    qrcode() {
      document.getElementById("qrcodeImg").innerHTML = "";

      new QRCode("qrcodeImg", {
        width: 150,
        height: 150,
        text:
          "https://steam.fun/scratch/h5player.html?work_type=2&work_id=" +
          this.workinfo.id +
          "&subject_code=2" + `&stuTchPlanIdTest=${this.stuTchPlanIdTest}&schoolIdTest=${this.schoolIdTest}`, // 二维码地址
        colorDark: "#000",
        colorLight: "#fff",
      });
    },

    LookCode() {
      console.log("学生查看课堂作品源码");

      if (this.workinfo.work_type == "1") {
        window.location.href =
          "/scratch/course.html?plan_id=" +
          this.workinfo.stu_tch_plan_id +
          "&operate=2";
      } else if (this.workinfo.work_type == "2") {
        window.location.href =
          "/scratch/course.html?plan_id=" +
          this.workinfo.stu_tch_plan_id +
          "&operate=4";
      }
    },

    ShowChatGPT() {
      // if (
      //   !this.drags.dragging &&
      //   this.drags.initPosition ===
      //   `${this.drags.offsetLeft}-${this.drags.offsetTop}`
      // ) {
      console.log("chatgpt 聊天");
      this.drawerAI = true;
      this.request_info = "";
      this.streamCache = "";
      // }
    },

    // 获得新的学生index页面数字统计信息
    getStuIndexNumInfoForNew() {
      getStuIndexNumInfoForNew().then((res) => {
        console.log(res);
        this.workNum = res.workNum; // 自由作品数
        this.tchWorkNum = res.tchWorkNum; // 课堂作品数
        this.loginDuration = res.loginDuration; // 登录时长
      });
    },
    // 获取学员星币信息
    stuStuStarPersonalSoa() {
      api_stuStuStarPersonalSoa({
        stuId: this.$store.state.user.userInfo.id,
        eduCampusId: this.$store.state.user.userInfo.eduCampusId,
      }).then((res) => {
        console.log(res);
        this.starData = res;
      });
    },
    async handleHomeSchoolCommunication(eventType) {
      console.log('eventType:', eventType)
      if (eventType === 'click') {
        this.publicAccountQrcode = await this.getQrCodeForStu();
        this.hoverShowQrcode = true;
        this.homeSchoolCommunicationShow = true;
      } else if (eventType === 'hover') {
        if (this.hoverShowQrcode) {
          this.homeSchoolCommunicationShow = true;
        }
      }
    },
    handleMouseLeaveHomeSchoolCommunication() {
      this.homeSchoolCommunicationShow = false;
    },
    handleChangeQrcodeType(typeLabel) {
      this.QrcodeType = typeLabel;
    },
    async getQrCodeForStu() {
      const res = await getQrCodeForStu()
      if (res.isBuffer) {
        const buffer = new Uint8Array(res.qucodeData.data);
        const blob = new Blob([buffer], { type: 'image/jpeg' });
        return URL.createObjectURL(blob);
      } else {
        return res.qucodeData;
      }
    }
  },
};
</script>

<style lang="scss" scoped>
div {
  box-sizing: border-box;
}
/**定义函数 如果小于1440， * (1440-当前页面宽度) / 100 */
$page-width: var(--page-width);
@function px-to-vw($px) {
  @return $px / 19.2 * 1vw;
}
.school-body {
  // height: calc(100vh - 75px);
  // background: #f1f7fe;
  // margin: 5px;
  min-height: 100%;
  box-sizing: border-box;
  // width: 1560px;
  padding: 70px 20px 0px;
  background-color: #f8f9fb;
  letter-spacing: 1px;
  .container {
    max-width: 1560px;
    min-width: 1180px;
    margin: auto;

    .home-top {
      margin-bottom: px-to-vw(35);
      .el-col {
        &.el-col-4 {
          width: 17%;
        }
        &.el-col-5 {
          width: 19.2%;
        }
        &.el-col-7 {
          flex: 1;
        }
        .virtual {
          position: relative;
          z-index: 1;
          .item-image {
            float: right;
            display: flex;
            justify-content: center;
            align-items: center;
            width: px-to-vw(140);
            height: px-to-vw(167);
            background: rgba(80, 153, 255, 0.1);
            border-radius: px-to-vw(16);
            img {
              display: block;
              height: 100%;
              transform-origin: bottom center;
              transform: scale(1.45);
            }
          }
          .popup-box {
            box-sizing: border-box;
            position: absolute;
            right: px-to-vw(170);
            top: px-to-vw(10);
            width: px-to-vw(280);
            min-height: px-to-vw(60);
            padding: px-to-vw(10);
            background-color: #fff;
            border-radius: px-to-vw(5);
            background-color: #e6eefb;
            &::after {
              position: absolute;
              top: 42%;
              right: px-to-vw(-18);
              content: "";
              border-width: px-to-vw(10);
              border-style: solid;
              border-top-color: transparent;
              border-right-color: transparent;
              border-bottom-color: transparent;
              border-left-color: #e6eefb;
            }
            div {
              max-height: 8vw;
              overflow: auto;
              font-size: 12px;
              line-height: px-to-vw(22);
              &::-webkit-scrollbar {
                display: none;
              }
              scrollbar-width: none;
            }
          }
        }

        .item-duration {
          height: px-to-vw(167);
          background: linear-gradient(
            180deg,
            #f0ecff 0%,
            #f7f6ff 19%,
            #fefefe 100%
          );
          border-radius: px-to-vw(24);
          img {
            width: px-to-vw(66);
          }
        }
        // .item-codeNum {
        //   height: 167px;
        //   background: #fff2f1;
        //   border-radius: 24px;
        //   img {
        //     width: 69px;
        //   }
        // }
        .item-finish {
          height: px-to-vw(167);
          background: linear-gradient(
            180deg,
            #fff7e7 0%,
            #fffdfa 41%,
            #fdfdfe 100%
          );
          border-radius: px-to-vw(24);
          cursor: pointer;
          img {
            width: px-to-vw(60);
          }
        }
        .item-works {
          height: px-to-vw(167);
          background: linear-gradient(
            180deg,
            #fff4fa 0%,
            #fef9fc 27%,
            #fdfdfd 100%
          );
          border-radius: px-to-vw(24);
          cursor: pointer;
          img {
            width: px-to-vw(70);
          }
        }
        .item-duration,
        // .item-codeNum,
        .item-finish,
        .item-works {
          display: flex;
          justify-content: center;
          align-items: center;
          border: 2px solid #ffffff;
          .text {
            display: inline-flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: space-between;
            padding-right: px-to-vw(25);
            padding-bottom: px-to-vw(15);
            span {
              padding-bottom: px-to-vw(10);
              font-size: px-to-vw(18);
            }
            strong {
              padding-top: px-to-vw(5);
              font-size: px-to-vw(18);
            }
          }
        }
        .item-classroom {
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 167px;
          padding: 0 25px 0 22px;
          background: linear-gradient(180deg, #e7ebff 0%, #fefefe 100%);
          border-radius: 15px;
          border: 2px solid #ffffff;
          cursor: pointer;
          .text {
            display: inline-flex;
            flex-direction: column;
            justify-content: space-between;
            height: 87px;
            margin-right: 10px;
            strong {
              font-size: 18px;
              font-weight: 500;
            }
            span {
              padding-bottom: 18px;
            }
          }
          img {
            width: 84px;
            height: 87px;
          }
        }
        .item-starCoins {
          display: flex;
          justify-content: center;
          align-items: center;
          height: px-to-vw(167);
          background: linear-gradient(
            180deg,
            #f3f5ff 0%,
            #fefefe 35%,
            #fefefe 100%
          );
          border-radius: px-to-vw(15);
          border: 2px solid #ffffff;
          cursor: pointer;
          .text {
            display: inline-flex;
            flex-direction: column;
            justify-content: space-between;
            height: px-to-vw(87);
            margin-right: px-to-vw(20);
            strong {
              font-size: px-to-vw(18);
              font-weight: bold;
            }
            span {
              display: inline-flex;
              align-items: center;
              padding-bottom: px-to-vw(15);
              font-size: px-to-vw(18);
              img {
                width: px-to-vw(27);
                margin-right: px-to-vw(10);
              }
            }
          }
          .starCoins-img {
            width: px-to-vw(120);
            height: px-to-vw(120);
          }
        }
      }
    }
    .home-create {
      padding: px-to-vw(35) px-to-vw(30);
      margin-bottom: px-to-vw(30);
      background-color: #fff;
      border-radius: px-to-vw(20);
      .el-row {
        .el-col {
          .item-jrcode,
          .item-scratch,
          .item-python,
          .item-c {
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: px-to-vw(130);
            border-radius: px-to-vw(10);
            transition: box-shadow 0.25s;
            cursor: pointer;
            &:hover {
              box-shadow: 0px 2px 4px 0px #c5c5c5;
            }
            .text {
              strong {
                display: flex;
                align-items: center;
                padding-bottom: px-to-vw(10);
                font-size: px-to-vw(18);
              }
            }
          }

          .item-jrcode {
            padding: 0 px-to-vw(12) 0 px-to-vw(35);
            background: linear-gradient(139deg, #f2ffe2 0%, #f6ffeb 100%);
            img {
              width: px-to-vw(135);
              height: px-to-vw(100);
            }
          }
          .item-scratch {
            padding: 0 px-to-vw(20) 0 px-to-vw(40);
            background: linear-gradient(133deg, #fff6f5 0%, #ffedeb 100%);
            img {
              width: px-to-vw(125);
              // height: px-to-vw(79);
            }
          }
          .item-python {
            padding: 0 px-to-vw(8) 0 px-to-vw(40);
            background: linear-gradient(139deg, #fffaef 0%, #ffedcb 100%);
            img {
              width: px-to-vw(121);
              // height: px-to-vw(97);
            }
            .update-version {
              margin-left: 5px;
              width: 20px;
              height: 20px;
              background: url("../../../../assets/image/stuUI/pyVersion.png")
                center / 100% no-repeat;
            }
          }
          .item-c {
            padding: 0 px-to-vw(20) 0 px-to-vw(40);
            background: linear-gradient(137deg, #f7fafe 0%, #e3eaf6 100%);
            img {
              // width: px-to-vw(108);
              height: px-to-vw(99);
            }
          }
        }
      }
    }
    .home-classroom-work {
      .title {
        padding-bottom: 15px;
        font-weight: 500;
        font-size: 16px;
      }
      .el-row {
        flex-wrap: wrap;
        .el-col {
          width: 20%;
          .item-classroom-work {
            position: relative;
            padding: 10px 10px 28px;
            margin-bottom: 15px;
            background: #ffffff;
            border-radius: 16px;
            cursor: pointer;
            .work-tag {
              position: absolute;
              top: 20px;
              right: 30px;
              display: flex;
              justify-content: center;
              align-items: center;
              width: 36px;
              height: 17px;
              background: rgba(74, 74, 74, 0.5);
              border-radius: 5px;
              font-weight: 400;
              font-size: 12px;
              color: #ffffff;
            }
            .img-box {
              box-sizing: border-box;
              margin-bottom: 10px;
              img {
                display: block;
                width: 100%;
                height: 140px;
                object-fit: cover;
                border-radius: 10px;
              }
            }
            .work-name {
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding: 0 5px 15px;
              font-weight: 400;
              font-size: 16px;
              color: #091b3d;
              .work_stuinfo_name_span {
                font-size: 14px;
                color: #909399;
                &.is_marking {
                  color: #67c23a;
                }
              }
            }
            .stu-info {
              display: flex;
              align-items: center;
              padding-left: 5px;
              .stu-head {
                width: 25px;
                height: 25px;
                border-radius: 5px;
                margin-right: 10px;
                object-fit: cover;
              }
              .stu-name {
                color: #666;
              }
            }
          }
        }
      }
    }
    // .home-ai {
    //   position: fixed;
    //   top: 0px;
    //   left: 0px;
    //   z-index: 999;
    //   cursor: pointer;
    //   img {
    //     width: 90px;
    //   }
    //   span {
    //     position: absolute;
    //     left: 50%;
    //     bottom: 0px;
    //     transform: translateX(-50%);
    //     display: inline-flex;
    //     justify-content: center;
    //     align-items: center;
    //     width: 83px;
    //     height: 26px;
    //     background: #1778ff;
    //     border-radius: 5px;
    //     font-weight: 400;
    //     font-size: 12px;
    //     color: #ffffff;
    //   }
    // }
  }

  .wrapper-up {
    .wrapper-up-content {
      background: white;
      height: calc((100vh - 60px) / 2 - 20px);
      margin: 5px;
      border-radius: 5px;

      .title {
        height: 50px;

        line-height: 50px;
        font-size: 20px;
        padding-left: 20px;
      }

      .content-up {
        height: calc((100vh - 60px) / 2 - 70px);
        overflow-y: auto;

        .content-up-imgwrapper {
          margin-top: 40%;
          padding: 10px;
          text-align: center;

          .content-up-img {
            width: 85px;
            height: 85px;
            border-radius: 40px;
            cursor: pointer;
          }
        }

        .content-up-txt {
          width: 100%;
          line-height: 20px;
          text-align: center;
        }

        .course_cover {
          width: 30px;
          height: 30px;
          border-radius: 5px;
        }

        .course_title {
          font-size: 14px;
        }

        .course_time {
          font-size: 10px;
        }

        .course_class {
        }

        .go_teach {
        }

        .courselist {
          padding: 10px;
        }

        .info_wrapper {
          .info_wrapper_1 {
            margin: 20px 10px 20px 10px;
            border: 1px solid rgb(240, 238, 238);
            border-radius: 5px;

            .info_wrapper_class {
              text-align: center;
              padding-top: 10px;
              color: rgb(138, 138, 138);
            }

            .info_wrapper_classnum {
              text-align: center;
              padding-bottom: 10px;
              font-size: 24px;
              font-weight: 500;
              color: 383838;
            }
          }
        }
      }
    }
  }

  .wrapper-down {
    .wrapper-down-content {
      background: white;
      height: calc((100vh - 60px) / 2 - 10px);
      margin: 5px;
      border-radius: 5px;

      .el-col-25 {
        width: 20%;
      }

      .worklist {
        background: white;
        border-radius: 5px;
        margin-bottom: 20px;
        border: 1px solid #e4e8ee;

        .worklist_imgwrapper {
          width: 100%;
          height: 0;
          padding-bottom: 75%;
          cursor: pointer;

          .workimg {
            width: 100%;
            border-radius: 5px 5px 0px 0px;
          }
        }

        .work_title {
          padding-top: 10px;
          margin-left: 5px;

          .work_title_span {
            font-size: 14px;
            color: #606266;

            width: 90%;
            overflow: hidden;
            /*内容超出后隐藏*/
            text-overflow: ellipsis;
            /* 超出内容显示为省略号 */
            white-space: nowrap;
            /* 文本不进行换行 */
          }
        }

        .work_stuinfo {
          margin-left: 5px;

          .work_stuinfo_avatar {
            float: left;
          }
        }

        .work_stuinfo_name {
          .work_stuinfo_name_span {
            margin-left: 5px;
            line-height: 30px;
          }
        }
      }

      .title {
        height: 50px;

        line-height: 50px;
        font-size: 20px;
        padding-left: 20px;
      }

      .content-up {
        height: calc((100vh - 60px) / 2 - 70px);

        .myclass {
          height: calc((100vh - 60px) / 2 - 150px);
          border: 1px solid rgb(238, 235, 235);
          margin-top: 20px;

          margin-left: 20px;
          border-radius: 10px;

          flex: 1;
          display: flex;
          flex-flow: column;

          .class_img {
            flex: 6;
            position: relative;

            .classimg {
              width: 100%;
              height: 98%;
              border-radius: 10px 10px 0px 0px;
            }

            .class_img_tag {
              position: absolute;
              top: 0;
              left: 0;
              z-index: 10;
            }
          }

          .class_room {
            flex: 1;
            font-weight: 800;
            padding-left: 5px;
          }

          .class_time {
            flex: 1;
            padding-left: 5px;
          }

          .class_num {
            flex: 1;
            padding-left: 5px;
          }
        }

        .myclass_goall {
          height: calc((100vh - 60px) / 2 - 150px);

          margin-top: 20px;
          margin-bottom: 40px;
          flex: 1;
          display: flex;
          flex-flow: column;

          line-height: calc((100vh - 60px) / 2 - 150px);
        }
      }
    }

    .contant {
      background: white;
      height: calc((100vh - 60px) / 2 - 10px);
      margin: 5px;
      border-radius: 5px;
      flex: 1;
      display: flex;
      flex-flow: column;

      .contant_img {
        width: 100%;
        height: 0;
        padding-bottom: 80%;

        .contant_img_1 {
          width: 80%;
          margin-top: 2%;
          margin-left: 10%;
        }
      }

      .contant_content {
        flex: 1;
        text-align: center;
      }

      .contant_btn {
        flex: 1;
        text-align: center;
      }
    }
  }
}

/deep/.hljs {
  padding: 20px;
  border-radius: 10px;
  margin-top: 10px;
  margin-bottom: 10px;
}
.fixed-right-elem {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  z-index: 999;
  right: 15px;
  bottom: 30vh;
  width: 70px;
  padding: 20px 5px;
  background-color: #fff;
  border-radius: 50px;
  box-shadow: 0px 2px 4px 1px #c4c4c4;
  &.qrcode-hide {
    background-color: initial;
    box-shadow: initial;
  }
  .home-school-communication,
  .home-ai {
    position: relative;
    z-index: 1;
    width: 100%;
    cursor: pointer;
    img {
      width: 100%;
    }
    .home-school-communication-wrapper {
      position: absolute;
      right: -300px;
      top: -80px;
      z-index: -1;
      width: 236px;
      height: 324px;
      background: url("../../../../assets/image/stuUI/homeSchoolCommuniCationBg.png")
        left / auto 100% no-repeat;
      // transition: all 0.25s;
      transition: all 0.3s ease-in-out;
      opacity: 0;
      pointer-events: none;
      &.show {
        right: 60px;
        opacity: 1;
        z-index: 1001;
        pointer-events: initial;
      }
      .qrcode-tabs {
        position: absolute;
        top: 98px;
        left: 40px;
        display: flex;
        align-items: center;
        width: max-content;
        border-radius: 50px;
        background: #fff;
        border: 1px solid #f8dfbf;
        overflow: hidden;
        &.only-one {
          left: 70px;
        }
        span {
          padding: 2px 10px;
          &.active {
            background-color: #f8dfbf;
          }
        }
      }
      .qrcode-img {
        position: absolute;
        top: 165px;
        left: 60px;
        width: 106px;
        // height: 100px;
        img {
          width: 100%;
        }
      }
      .qrcode-right {
        position: absolute;
        top: 100px;
        right: 10px;
        width: 20px;
      }
    }
  }
  .home-line {
    width: 40px;
    height: 1px;
    margin: 25px 0;
    background-color: #eee;
  }
}
</style>

<style>
.school-body .el-card__body {
  padding: 20px;
}
</style>
